import React from 'react';
import NavbarAdmin from '../components/NavbarAdmin';
import NavItem from '../components/NavItem';
import './styles/Main.css'; // Add styles here
const Main = () => {
  return (
    <div>
      <NavbarAdmin />
      <div className='admin-content'>
        <div className='nav-items-container'>
          <NavItem 
            title='Les Actualités'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addActualite'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeActualites'
          />
          <NavItem 
            title='Les Projets'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addProject'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeProjets'
          />
          <NavItem 
            title='Recrutement Staff'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addJobStaff'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeJobStaff'
          />
          <NavItem 
            title='Comité'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addcomite'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listecomite'
          />
          <NavItem 
            title='Les états financiers'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addetatfinance'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeetats'
          />
          <NavItem 
            title='Recrutement Consultant'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addJobConsultant'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeJobConsultant'
          />
          <NavItem 
            title='Statistiques par Genre'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addStatGenre'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeStatGenre'
          />
          <NavItem 
            title='Statistiques par Secteur'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addStatDomaine'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listeStatDomaine'
          />
          
          <NavItem 
            title='Les Références Juridiques'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/addreflegal'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listereflegal'
          />
          
          <NavItem 
            title='Documents à Télécharger'
            addLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/adddoc'
            manageLink='/la-connexion-de-ladmin-ong-el-wifak-bargou/listedoc'
          />
        </div>
      </div>
    </div>
  );
};

export default Main;